import {Editor, Transforms} from 'slate'

export const selectStartOfNote = (editor: Editor) => {
  const [, firstPath] = Editor.first(editor, [])
  Transforms.select(editor, Editor.start(editor, firstPath))
}
